<div class="w-100">
    <mwp-card-content-header [url]="apiUrl" />
    <div>
        <mwp-table [tableColumns]="form1095sColumns" [dataSource]="form1095sMatTableData" (emitButtonSelection)="downloadForm1095($event)" (emitButtonSelection2)="emailDocument($event)" header="Form 1095s" />
    </div>
</div>